<!-- 详情弹窗 -->
<template>
  <a-modal
    title="详情"
    :width="680"
    :footer="null"
    :visible="visible"
    @update:visible="updateVisible"
  >
    <a-form
      class="ud-form-detail"
      :label-col="{ sm: { span: 11 }, xs: { span: 6 } }"
      :wrapper-col="{ sm: { span: 16 }, xs: { span: 18 } }"
    >
      <a-row :gutter="16">
        <a-col :sm="12" :xs="24">
          <!-- 所属运营商 -->
          <a-form-item label="客户ID:">
            <div class="ud-text-secondary">
              {{ data.userId }}
            </div>
          </a-form-item>
          <!-- 厂家 -->
          <a-form-item label="手机号:">
            <div class="ud-text-secondary">
              {{ data.phone }}
            </div>
          </a-form-item>
          <!-- 型号 -->
          <a-form-item label="真实姓名:">
            <div class="ud-text-secondary">{{ data.realName }}</div>
          </a-form-item>
          <!-- 机柜尺寸 -->
          <a-form-item label="身份证号码:">
            <div class="ud-text-secondary">{{ data.idCard }}</div>
          </a-form-item>
          <a-form-item label="余额(元):">
            <div class="ud-text-secondary">{{ data.balances }}</div>
          </a-form-item>
        </a-col>
        <a-col :sm="12" :xs="24">
          <!-- 仓位尺寸 -->
          <a-form-item label="赠送余额(元):">
            <div class="ud-text-secondary">
              {{ data.giftAmount }}
            </div>
          </a-form-item>
          <!-- 屏幕尺寸 -->
          <a-form-item label="押金(元):">
            <div class="ud-text-secondary">
              {{ data.deposit }}
            </div>
          </a-form-item>
          <!-- 仓位数 -->
          <a-form-item label="注册时间:">
            <div class="ud-text-secondary">
              {{ data.createTime }}
            </div>
          </a-form-item>
          <!-- 防水等级 -->
          <a-form-item label="所属租赁点:">
            <div class="ud-text-secondary">
              {{ data.pointName }}
            </div>
          </a-form-item>
          <a-form-item label="所属运营商:">
            <div class="ud-text-secondary">
              {{ data.operatorName }}
            </div>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'brandDetail',
  emits: ['update:visible'],
  props: {
    // 弹窗是否打开
    visible: Boolean,
    // 数据
    data: Object
  },
  methods: {
    /* 更新visible */
    updateVisible(value) {
      this.$emit('update:visible', value)
    }
  }
}
</script>

<style scoped>
</style>
